/** Currency to display prices in */
export enum Currency {
  CHF = 'CHF',
  EUR = 'EUR',
  GBP = 'GBP',
}
